import { STATUS_BOARD_LNB_COLLAPSED_COOKIE } from '@kc-console/guard';

/**
 * LNB 접힘/펼침 상태 세션 쿠키 갱신
 */
export const setLnbCollapsedSessionCookie = (collapsed: boolean): void => {
  if (typeof document === 'undefined') return;

  const value = collapsed ? 'true' : 'false';
  document.cookie = `${STATUS_BOARD_LNB_COLLAPSED_COOKIE}=${value}; Path=/; SameSite=Lax`;
};
